import { Controller } from "@hotwired/stimulus";
import iconRemove from "../../images/icon-remove.svg";

export default class extends Controller {
  static targets = ["list"];
  static values = {
    prefectures: Array,
    jobCategories: Array,
    employmentKinds: Array,
    incomeRanges: Array,
    workStyles: Array
  };

  connect() {
    this.prefectureMap = {};
    this.prefecturesValue.forEach(([id, name]) => {
      this.prefectureMap[id.toString()] = name;
    });

    this.jobCategoryMap = {};
    this.jobCategoriesValue.forEach(([id, name]) => {
      this.jobCategoryMap[id.toString()] = name;
    });

    this.employmentKindMap = {};
    this.employmentKindsValue.forEach(([id, name]) => {
      this.employmentKindMap[id.toString()] = name;
    });

    this.incomeRangeMap = {};
    this.incomeRangesValue.forEach(([id, name]) => {
      this.incomeRangeMap[id.toString()] = name;
    });

    this.workStyleMap = {};
    this.workStylesValue.forEach(([id, name]) => {
      this.workStyleMap[id.toString()] = name;
    });

    this.renderTags();
  }

  renderTags() {
    this.listTarget.innerHTML = "";
    const form = this.element.closest("form");
    if (!form) return;

    this.renderCheckedTags(form, 'prefectures[]', (id) => this.prefectureName(id));
    this.renderCheckedTags(form, 'job_categories[]', (id) => this.jobCategoryName(id));
    this.renderCheckedTags(form, 'employment_kinds[]', (id) => this.employmentName(id));
    this.renderCheckedTags(form, 'work_styles[]', (id) => this.workStyleName(id));
    this.renderCheckedTags(form, 'income[]', (id) => this.incomeName(id));
  }

  renderCheckedTags(form, paramName, nameResolver) {
    form.querySelectorAll(`input[name="${paramName}"]:checked`).forEach(cb => {
      const name = nameResolver(cb.value);
      if (name) this.appendTag(name, paramName, cb.value);
    });
  }

  // マスタデータ由来の名称でも innerHTML には流さず、テキストノードとして組み立てる
  appendTag(name, paramType, paramValue) {
    const li = document.createElement("li");
    li.className = "jobs-search-conditions__item";
    li.append(name);

    const button = document.createElement("button");
    button.type = "button";
    button.className = "jobs-search-conditions__remove-button";
    button.setAttribute("aria-label", `${name}を削除`);
    button.addEventListener('click', () => {
      this.removeTag(paramType, paramValue);
    });

    const icon = document.createElement("img");
    icon.src = iconRemove;
    icon.alt = "削除する";
    icon.className = "jobs-search-conditions__remove-icon";

    button.append(icon);
    li.append(button);
    this.listTarget.appendChild(li);
  }

  removeTag(paramType, paramValue) {
    const form = this.element.closest("form");
    if (!form) return;
    const checkbox = form.querySelector(`input[name="${paramType}"][value="${paramValue}"]`);
    if (checkbox) checkbox.checked = false;
    form.requestSubmit();
  }

  prefectureName(prefectureId) {
    return this.prefectureMap ? this.prefectureMap[prefectureId] : prefectureId;
  }

  jobCategoryName(jobCategoryId) {
    return this.jobCategoryMap ? this.jobCategoryMap[jobCategoryId] : jobCategoryId;
  }

  employmentName(employmentKindId) {
    return this.employmentKindMap ? this.employmentKindMap[employmentKindId] : employmentKindId;
  }

  workStyleName(workStyleId) {
    return this.workStyleMap ? this.workStyleMap[workStyleId] : workStyleId;
  }

  incomeName(incomeRangeId) {
    return this.incomeRangeMap ? this.incomeRangeMap[incomeRangeId] : incomeRangeId;
  }
}
